module.exports = __webpack_public_path__ + "static/media/tire-rotation-red.5cfef387.svg";